import { useEffect, useState } from 'react';
import { TokenType } from '../../../../common/enums/tokenType';
import { ValidationErrorCode } from '../../../../common/enums/validationErrorCode';
import { fetchJson } from '../../../store/fetch';
import { Loader } from '../../elements/common';
import { GeneralError } from '../errors/GeneralError';
import { ActivateAccount } from './ActivateAccount';
import { IdleUserModalNotLoggedIn } from './IdleUserModalNotLoggedIn';
import { ResetMfa } from './ResetMfa';
import { ResetPassword } from './ResetPassword';
import { SetHardwareToken } from './SetHardwareToken';

interface IMainNotLoggedInViewsProps {
    token?: string;
    viewName?: string;
}

export function MainNotLoggedInViews({ viewName, token }: IMainNotLoggedInViewsProps) {
    const [tokenType, setTokenType] = useState<TokenType>();
    const [tokenTypeLoaded, setTokenTypeLoaded] = useState(false);
    const isActivationToken = tokenType && [TokenType.activation, TokenType.initialActivation].includes(tokenType);
    useEffect(() => {
        loadToken();
    });

    let view: JSX.Element;

    if (!tokenTypeLoaded) {
        view = (
            <Loader
                centered
                large
            />
        );
    } else if (token && tokenType && tokenTypeLoaded) {
        if (isActivationToken && !viewName) {
            view = <ActivateAccount activationToken={token ?? ''} />;
        } else if (tokenType === TokenType.resetPassword) {
            view = <ResetPassword token={token} />;
        } else if (tokenType === TokenType.resetMfa) {
            view = <ResetMfa token={token} />;
        } else if (tokenType === TokenType.setHardwareToken) {
            view = (
                <SetHardwareToken
                    redirectHome
                    token={token}
                />
            );
        } else {
            view = <GeneralError />;
        }
    } else {
        view = <GeneralError />;
    }

    return (
        <>
            {view}
            <IdleUserModalNotLoggedIn />
        </>
    );

    async function loadToken() {
        if (token) {
            const result = await fetchJson(
                `api/activationTokens/${token}?includeExpired=true`,
                'GET',
                undefined,
                [ValidationErrorCode.ACTIVATION_TOKEN_EXPIRED, ValidationErrorCode.ACTIVATION_TOKEN_ALREADY_CONSUMED],
                [400, 404]
            );
            if (result.json?.type) {
                setTokenType(result.json?.type as TokenType);
            }
            setTokenTypeLoaded(true);
        } else {
            setTokenTypeLoaded(true);
        }
    }
}
